import { useFetchData } from 'app/hooks/store';
import { UserEntity } from 'app/interfaces/entity';
import { debounce, uniqBy } from 'lodash';
import { getSearchUsersList } from 'modules/users/store/search-users/repository';
import { searchUsersSelector } from 'modules/users/store/search-users/selectors';
import { ChangeEvent, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

export const useSearchUsers = (activeUsers: UserEntity[] = [], withActiveUser = false) => {
  const [searchQuery, setSearchQuery] = useState('');
  const users: UserEntity[] = useSelector(searchUsersSelector.all);

  const actions = useMemo(
    () => [getSearchUsersList({ search: searchQuery, withActiveUser })],
    [withActiveUser, searchQuery]
  );
  const { fetch, loading } = useFetchData(actions, { fetchOnInit: false });

  const changeHandler = debounce(
    (event: ChangeEvent<HTMLInputElement>) => setSearchQuery(event.target.value),
    300
  );

  const filteredUsers = useMemo(
    () => uniqBy([...activeUsers, ...users], 'id'),
    [activeUsers, users]
  );

  useEffect(() => {
    if (searchQuery.length) {
      fetch();
    }
  }, [fetch, searchQuery]);

  return { changeHandler, users: filteredUsers, loading };
};
